import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { Button } from './ui/button';
import { HelpCircle, ArrowRight } from 'lucide-react';
import { articlesForRole } from '../data/helpGuides';

const renderIntro = (intro) => {
  if (!intro) return null;
  const paras = Array.isArray(intro) ? intro : [intro];
  return paras.map((p, i) => <p key={i} className="text-sm text-slate-600 leading-relaxed mb-2">{p}</p>);
};

// Botão de ajuda contextual: abre os guias da categoria indicada (filtrados pelo perfil).
export const HelpButton = ({ category, className = '' }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const cat = articlesForRole(user?.role).find((c) => c.id === category);
  if (!cat) return null; // o perfil não tem guias para esta área

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className={`gap-1.5 text-slate-500 hover:text-[#2D3E6F] ${className}`}
        data-testid={`help-button-${category}`}
        title="Ajuda sobre esta área"
      >
        <HelpCircle className="w-4 h-4" /> Ajuda
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid={`help-dialog-${category}`}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-[#2D3E6F]">
              <HelpCircle className="w-5 h-5" /> Ajuda · {cat.title}
            </DialogTitle>
          </DialogHeader>
          <Accordion type="single" collapsible className="w-full">
            {cat.articles.map((a, idx) => (
              <AccordionItem key={idx} value={`${cat.id}-${idx}`} className="border-slate-100">
                <AccordionTrigger className="text-sm font-medium text-slate-700 hover:no-underline text-left" data-testid={`help-dialog-q-${idx}`}>
                  {a.q}
                </AccordionTrigger>
                <AccordionContent className="pb-3">
                  {renderIntro(a.intro)}
                  {a.steps && (
                    <ol className="list-decimal list-inside space-y-1.5 text-sm text-slate-600 mt-1">
                      {a.steps.map((s, si) => <li key={si} className="leading-relaxed">{s}</li>)}
                    </ol>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <Button
            variant="ghost"
            className="w-full justify-center text-[#2D3E6F] mt-1"
            onClick={() => { setOpen(false); navigate('/centro-ajuda'); }}
            data-testid="help-dialog-open-full"
          >
            Abrir Centro de Ajuda completo <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HelpButton;
